<template>
  <div class="form-group">
    <label v-if="label" v-bind:for="id" class="form-label">{{ label }}
      <i v-if="parseBoolean(required)" class="far fa-asterisk"></i>
      <span v-if="language" class="language"> ({{ language }})</span>
    </label>
    <div class="form-check" v-bind:class="{'is-invalid': invalid}">
      <input v-bind:id="id"
             type="checkbox"
             v-bind:checked="value"
             v-on:change="changed"
             v-bind:disabled="disabled"
             class="form-check-input"
             v-bind:class="{'is-invalid': invalid}"/>
      <label v-if="optionLabel" v-bind:for="id" class="form-check-label">{{ optionLabel }}</label>
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "select-boolean-checkbox",
  computed: {
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  },
  methods: {
    changed: function () {
      this.$emit("input", !this.value);
    }
  },
  props: ["id", "value", "errors", "label", "optionLabel", "disabled"]
}
</script>
